import React from 'react';

import { BylineContainer, BylineMessageContainer } from './ContentOwnershipStyles.tsx';
import { PageOwnershipBylineContent } from './PageOwnershipBylineContent.tsx';
import type { UserShape } from './ownership-models.ts';

type PageOwnershipBylineProps = {
	owner: UserShape;
	templateId: string | null;
	generatedBy?: string | null;
};
export const PageOwnershipByline = ({
	owner,
	templateId,
	generatedBy,
}: PageOwnershipBylineProps) => {
	return (
		<BylineContainer>
			<BylineMessageContainer>
				<PageOwnershipBylineContent
					owner={owner}
					templateId={templateId}
					abbreviateBylineText
					generatedBy={generatedBy}
				/>
			</BylineMessageContainer>
		</BylineContainer>
	);
};
